module.exports = __webpack_public_path__ + "img/l.e81b23f0.webp";